import gql from 'graphql-tag';

const financingSacksHectaresInfo = `
  id
  state {
    id
    name
    code
  }
  campaign {
    id
    name
  }
  pricePerBag
  bagsPerHectares
`;

export const getAllFinancingSacksHectares = gql`
  query {
    financingSacksHectares {
      ${financingSacksHectaresInfo}
    }
  }
`;

export const deleteSacksHectares = gql`
  mutation deleteSacksHectares($sacksHectaresId: String!) {
    deleteSacksHectares(sacksHectaresId: $sacksHectaresId) {
      id
    }
  }
`;

export const updateSacksHectares = gql`
  mutation  updateSacksHectares($sacksHectaresUpdatedInfo: AgUpdateSacksHectaresInput!) {
    updateSacksHectares(sacksHectaresUpdatedInfo: $sacksHectaresUpdatedInfo) {
      ${financingSacksHectaresInfo}
    }
  }
`;

export const createSacksHectares = gql`
  mutation  createSacksHectares($sacksHectaresNewInfo: AgCreateSacksHectaresInput!) {
    createSacksHectares(sacksHectaresNewInfo: $sacksHectaresNewInfo) {
      ${financingSacksHectaresInfo}
    }
  }
`;
